import { AdvancedFilterDataSchema } from "@redotech/redo-views-common/advanced-filters/advanced-filter-data";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const InboundConsolidationItemKinds = [
  "product",
  "return",
  "unknown",
] as const;
export type InboundConsolidationItemKind =
  (typeof InboundConsolidationItemKinds)[number];

export const InboundConsolidationItemStatuses = [
  "eligible",
  "registered",
  "partially_packed",
  "packed",
] as const;
export type InboundConsolidationItemStatus =
  (typeof InboundConsolidationItemStatuses)[number];

export const INBOUND_CONSOLIDATION_ITEM_FILTER_NAMES = {
  status: "status",
  kind: "kind",
  disposition: "disposition",
  grade: "grade",
} as const;

export const INBOUND_CONSOLIDATION_ITEM_UNASSIGNED_DISPOSITION =
  "__redo_unassigned__";

const inboundConsolidationItemSchema_ = z.object({
  inventoryItemId: z.string(),
  kind: z.enum(InboundConsolidationItemKinds),
  productTitle: z.string().nullable(),
  variantTitle: z.string().nullable(),
  sku: z.string().nullable(),
  returnOrderName: z.string().nullable(),
  returnHref: z.string().nullable(),
  inWarehouseSince: z.date(),
  storageLocationNames: z.array(z.string()),
  cartonNumbers: z.array(z.number()),
  disposition: z.string().nullable(),
  grade: z.string().nullable(),
  status: z.enum(InboundConsolidationItemStatuses),
});
export const inboundConsolidationItemSchema: z.ZodType<InboundConsolidationItem> =
  inboundConsolidationItemSchema_;
export interface InboundConsolidationItem extends z.infer<
  typeof inboundConsolidationItemSchema_
> {}

export const listInboundConsolidationItems = unaryRpc({
  name: "listInboundConsolidationItems" as const,
  input: z.object({
    consolidationId: z.string(),
    page: z.number().int().min(0).default(0),
    pageSize: z.number().int().min(1).max(200).default(25),
    search: z.string().max(200).optional(),
    advancedFiltersData: z.array(AdvancedFilterDataSchema).optional(),
  }),
  output: z.object({
    items: z.array(inboundConsolidationItemSchema),
    totalCount: z.number().int(),
  }),
});
